import { css } from "@emotion/react";
import { lineClamp1Css } from "assets/css/lineClamp.css";

export default {
  container: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 45px;
  `,
  header: [
    lineClamp1Css,
    css`
      flex: 1 1 0;
      margin: 0;
    `,
  ],
};
